export default "__VITE_ASSET__B6c3JhQc__"